import React from 'react';
import { Star, Quote } from 'lucide-react';
import { Section } from './ui/Section';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { useLanguage } from '../hooks/useLanguage';
export function TestimonialsSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  const {
    t
  } = useLanguage();
  const testimonials = [{
    name: t('testimonials', 't1Name'),
    role: t('testimonials', 't1Role'),
    text: t('testimonials', 't1Text'),
    rating: 5
  }, {
    name: t('testimonials', 't2Name'),
    role: t('testimonials', 't2Role'),
    text: t('testimonials', 't2Text'),
    rating: 5
  }, {
    name: t('testimonials', 't3Name'),
    role: t('testimonials', 't3Role'),
    text: t('testimonials', 't3Text'),
    rating: 5
  }];
  return <Section background="stone" id="testimonials" data-id="element-228">
      <div ref={ref} className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20'}`} data-id="element-229">
        <div className="text-center mb-16" data-id="element-230">
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-brand-navy mb-4" data-id="element-231">
            {t('testimonials', 'title1')}
            <span className="text-slate-400 line-through decoration-brand-fire decoration-4" data-id="element-232">
              {t('testimonials', 'title2')}
            </span>
            <span className="text-brand-blue-light" data-id="element-233">
              {t('testimonials', 'title3')}
            </span>
          </h2>
          <p className="text-slate-500" data-id="element-234">{t('testimonials', 'desc')}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-235">
          {testimonials.map((t, idx) => <div key={idx} className="bg-white p-8 rounded-xl shadow-md border border-slate-100 relative hover:shadow-lg hover:-translate-y-1 transition-all duration-300" data-id="element-236">
              <Quote className="absolute top-4 right-4 text-brand-blue/10 w-12 h-12" data-id="element-237" />

              <div className="flex gap-1 mb-4" data-id="element-238">
                {[...Array(t.rating)].map((_, i) => <Star key={i} className="w-5 h-5 text-brand-amber fill-brand-amber" data-id="element-239" />)}
              </div>

              <p className="font-handwritten text-2xl text-slate-700 mb-6 leading-relaxed" data-id="element-240">
                "{t.text}"
              </p>

              <div className="border-t border-slate-100 pt-4" data-id="element-241">
                <p className="font-bold text-brand-navy font-heading uppercase tracking-wider" data-id="element-242">
                  {t.name}
                </p>
                <p className="text-xs text-brand-blue-light uppercase" data-id="element-243">
                  {t.role}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </Section>;
}